import { render, staticRenderFns } from "./ProvidersEdit.vue?vue&type=template&id=864c863c"
import script from "./ProvidersEdit.vue?vue&type=script&lang=js"
export * from "./ProvidersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports